"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var React = require("react");
var Label_styled_1 = require("./Label.styled");
exports.Label = function (props) { return (React.createElement(Label_styled_1.StyledLabel, null,
    props.title && React.createElement("label", { htmlFor: props.id }, props.title),
    props.value && (React.createElement("label", { className: props.className, htmlFor: props.id }, props.value)))); };
exports.Label.defaultProps = {};
//# sourceMappingURL=Label.js.map